export function formatReviewStatus(reviewStatus) {
    return reviewStatus.replaceAll("_", " ")
  }